import React from 'react'

export default function RegisterProductInnerStyle() {
  return (
    <style jsx="true">
    {`
      html {
        --margin-right: 250px;
      }

      /*DROP DOWN MENU LIKE BEGIN*/
        .action-btn-menu {
          position: absolute;
          top: 0;
          left: -70px;
          display: flex;
          justify-content: center;
          text-align: center;
          border-radius: 3px;
          font-size: 0.7em;
          z-index: 1;
          display: none;
        }
        .dd-menu { position: relative; }
        .show-dd-menu { display: flex; }

        .pospro-action-btn.edit-row-btn {
          background-color: rgba(0, 255, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.edit-row-btn:hover { background-color: rgba(0, 205, 0, 1); }

        .pospro-action-btn.del-row-btn {
          background-color: rgba(255, 0, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.del-row-btn:hover { background-color: rgba(205, 0, 0, 1); }
      /*DROP DOWN MENU LIKE END*/


      #delete-unit-description {
        padding: 3px 10px;
        border: solid 0.4px rgba(100, 140, 88, 1);
        background-color: rgba(200, 230, 180, 1);
        border-radius: 50px;
      }

      #unit-description-container {
        /*text-align: center;*/
        font-size: 0.8em;
        padding: 5px;
        margin: 5px;
        /*
        border: solid 0.4px rgba(100, 140, 88, 1);
        background-color: rgba(200, 230, 180, 1);
        border-radius: 50px;
        */
      }

      .acl-container {
        position: relative;
      }

      .item-error-text {
        color: red;
        padding: 10px;
        border: solid 1px rgba(23, 23, 100, 0.4);
      }

      #register-products-form {
        color: rgba(4, 102, 128, 1);
        /*background-color: whitesmoke;*/
        margin-right: var(--margin-right);
        border-radius: 5px;
        margin-bottom: 10px;
        padding: 0 20px;
        padding-bottom: 10px;
      }

      #register-products-form h4 {
        padding: 20px 10px;
      }

      #item-description-container {
        font-size: 0.8em;
      }

      .form-group {
        display: flex;
        padding: 10px 10px;
      }

      .form-group label {
        flex: 2;
      }

      .form-group .input-container {
        display: flex;
        flex-direction: column;
        flex: 9;
      }

      input[type='text'] {
        /*position: relative;*/
        /*width: 100%;*/
        /*flex: 9;*/
        padding: 5px;
        font-size: 0.9em;
        border-radius: 3px;
        border: solid 1px lightblue;
      }

      .input-container .item-error {
        border: solid 2px red;
      }

      .form-group #status {
        display: flex;
        flex: 9;
      }

      .form-group #status * {
        margin-right: 10px;
      }

      #item-unit-details {
        display: flex;
        flex-direction: column;
        border: solid lightgrey 1px;
        margin-bottom: 10px;
      }

      #item-unit-details #add-unit-btn {
        align-self: flex-end;
        margin: 10px 5px;
      }

      #item-unit-details table {
        width: 100%;
        justify-content: stretch;
        border-spacing: 0;
      }

      #item-unit-details table thead {
        background-color: transparent;
      }

      #item-unit-details table th {
        border-top: solid lightgrey 2px;
        border-bottom: solid lightgrey 1px;
        padding: 10px 5px;
        font-size: 0.650em;
      }

      #item-unit-details table td {
        font-size: 0.650em;
        padding: 3px;
        user-select: text;
      }

      #item-unit-details table th:nth-child(4), td:nth-child(4)  {
        text-align: center;
      }

      .messagebox {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 10px;
      }
      .messagebox-content {
        height: 100%;
        flex: 2;
      }

      .button-container {
        display: flex;
        justify-content: flex-end;
        padding: 5px;
      }
    `}
    </style>
  )
}
